import {useState, useEffect} from "react";
import {useParams, Link} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

export const ReportS1 = () => {
    const {year, settlement_ekatte} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/s1/${year}/${settlement_ekatte}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, settlement_ekatte]);

    const handlePdf = () => {
        downloadPdf(`/reports/s1/${year}/${settlement_ekatte}?format=pdf`, `S1_${settlement_ekatte}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const s = data.settlement;
    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С1 — Справка на землище</h5>
                    <div>{s.settlement}, община {s.municipality}, област {s.region} | ЕКАТТЕ: {s.ekatte}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            <div className="table-responsive">
                <table className="table table-sm table-bordered">
                    <thead className="tableHead">
                    <tr>
                        <th>Ползвател</th>
                        <th>Булстат</th>
                        <th className="text-end">Деклар.</th>
                        <th className="text-end">Негодна</th>
                        <th className="text-end">Годна</th>
                        <th className="text-end">БП</th>
                        <th className="text-end">Пътища</th>
                        <th className="text-end">ДЗ</th>
                        <th className="text-end">Правно</th>
                        <th className="text-end">Изчерт.</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.rows.map((row, i) => (
                        <tr key={i}>
                            <td>
                                <Link to={`/info/${year}/${settlement_ekatte}/${row.bullstat}`}
                                      style={{textDecoration: "none", color: "var(--app-gold)"}}>
                                    {row.company_name}
                                </Link>
                            </td>
                            <td>{row.bullstat}</td>
                            <td className="text-end">{row.declared_land.toFixed(2)}</td>
                            <td className="text-end">{row.unsuitable_land.toFixed(2)}</td>
                            <td className="text-end">{row.suitable_land.toFixed(2)}</td>
                            <td className="text-end">{row.white_spots.toFixed(2)}</td>
                            <td className="text-end">{row.roads.toFixed(2)}</td>
                            <td className="text-end">{row.deals_sum.toFixed(2)}</td>
                            <td className="text-end">{row.pravno.toFixed(2)}</td>
                            <td className="text-end">{row.drawings_sum.toFixed(2)}</td>
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    <tr className="fw-bold">
                        <td>ОБЩО</td>
                        <td></td>
                        {["declared_land", "unsuitable_land", "suitable_land", "white_spots", "roads",
                            "deals_sum", "pravno", "drawings_sum"].map(key => (
                            <td key={key} className="text-end">
                                {data.rows.reduce((sum, r) => sum + r[key], 0).toFixed(2)}
                            </td>
                        ))}
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};
